<template>
  <a-modal
    :title="form.id ? '修改权益' : '新增权益'"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    destroyOnClose
    :maskClosable="false"
    width="500px"
  >
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="权益名称" prop="name">
        <a-input
          v-model="form.name"
          placeholder="请输入权益名称"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        id: "",
        name: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入权益名称",
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      this.form.id = id;
      if (id) {
        this.$http({
          url: "/admin/benefittag/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = { ...res.data };
        });
      }
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: this.form.id
              ? "/admin/benefittag/update"
              : "/admin/benefittag/create",
            method: "post",
            data: this.form,
          })
            .then(() => {
              this.$message.success(this.form.id ? "修改成功" : "创建成功");
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style>
</style>
